<div class="discount-item">
  <span class="discount-item__info">
    <span class="discount-name">
      {{ 'payment-info.discount-item.coupon' | translate }}
      <b>{{ coupon.name }}</b>
    </span>
    <span class="discount-remove" *ngIf="canRemove">
        <a (click)="onRemoveCoupon.emit()">{{'payment-info.discount-item.coupon-remove' | translate}}</a>
    </span>
  </span>
  <span class="discount-item__price">
    -{{coupon.amount | countryCurrency: currency:'symbol':'1.1-3':locale}}
  </span>
</div>